import styled from 'styled-components';

export const Panel = styled.div`
  background: #fafdff;
  border: 1px solid #cce9fd;
  border-radius: 16px;
  padding: 30px;

  margin: 40px 0;
`;

export const PanelLight = styled.div`
  background: #fafdff;
  border: 1px solid #cce9fd;
  border-radius: 6px;
  padding: 16px;
  margin: 0px 0 30px 0px;
`;

export const PanelWithBottom = styled.div`
  background: #fafdff;
  border: 1px solid #cce9fd;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 30px;
`;

export const PanelWithBottomContent = styled.div`
  background: #ffffff;
  border: 1px solid #cce9fd;
  border-top: 0px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 20px;
  margin-bottom: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const StyledList = styled.ul`
  list-style: disc;
  padding: 0;
  padding-left: 1em;
  margin: 0;
  li {
    margin-bottom: 10px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #dbdfe5;
  margin: 20px 0;
`;
